import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29')
];

export const server_loads = [];

export const dictionary = {
		"/": [8],
		"/faq": [9],
		"/leerlijnen": [10],
		"/leerlijnen/[gameFormatId]": [11],
		"/leerlijnen/[gameFormatId]/[id]--[slug]": [12],
		"/logboek": [13],
		"/oefeningen": [14,[2]],
		"/oefeningen/[id]--[slug]": [15,[2]],
		"/planning": [16],
		"/spelersgroep-[id]": [17],
		"/spelersgroep-[id]/logboek": [18],
		"/spelersgroep-[id]/oefeningen": [19,[3]],
		"/spelersgroep-[id]/oefeningen/[id]--[slug]": [20,[3]],
		"/spelersgroep-[id]/planning": [21],
		"/spelersgroep-[id]/trainingen": [22,[4]],
		"/spelersgroep-[id]/trainingen/[id]": [23,[4,5]],
		"/spelersgroep-[id]/trainingsplannen": [24],
		"/spelersgroep-[id]/trainingsplannen/[gameformat]": [25],
		"/trainingen": [26,[6]],
		"/trainingen/[id]": [27,[6,7]],
		"/trainingsplannen": [28],
		"/trainingsplannen/[gameformat]": [29]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';